import { render, staticRenderFns } from "./ProductSpecial.vue?vue&type=template&id=830c1124&scoped=true"
import script from "./ProductSpecial.vue?vue&type=script&lang=js"
export * from "./ProductSpecial.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecial.vue?vue&type=style&index=0&id=830c1124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830c1124",
  null
  
)

export default component.exports